import { Outlet } from 'react-router-dom';

import { PageContent } from '@components/Page';

export const Reports = () => {
  return (
    <PageContent>
      <Outlet />
    </PageContent>
  );
};
